import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/', label: '首页' },
    { path: '/products', label: '产品中心' },
    { path: '/solutions', label: '行业应用' },
    { path: '/about', label: '关于我们' },
    { path: '/news', label: '新闻资讯' },
    { path: '/contact', label: '联系我们' },
    { path: '/sources', label: '资源中心' }
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      isScrolled ? 'bg-white/90 backdrop-blur-xl shadow-xl border-b border-gray-100' : 'bg-transparent'
    }`}>
      <div className="container-max px-2">
        <div className="flex items-center justify-between h-12 lg:h-16">
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="relative">
              <div className="w-28 h-8 bg-transparent flex items-center justify-center transform group-hover:scale-110 transition-all duration-500">
                {/*<i className="fas fa-robot text-primary-100 text-xl"></i>*/}
                <img
                  src={require('../static/img/logo.png')}
                  alt="LX机器人"
                  // className="w-8 h-8"
                />
              </div>
              <div className="absolute inset-0 w-8 h-8 bg-gradient-to-br from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
            {/*<span className={`text-2xl font-black transition-colors duration-300 ${*/}
            {/*  isScrolled ? 'text-primary-900' : 'text-primary-100'*/}
            {/*} group-hover:text-primary-600`}>*/}
            {/*  LX机器人*/}
            {/*</span>*/}
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative font-semibold transition-all duration-300 hover:scale-105 group ${
                  // location.pathname === item.path
                  //   ? 'text-primary-100'
                  //   : 
                    isScrolled ? 'text-primary-700 hover:text-primary-600' : 'text-primary-500 hover:text-primary-600'
                }`}
              >
                {item.label}
                <div className={`absolute -bottom-1 left-0 h-0.5 transition-all duration-300 ${
                  location.pathname === item.path ? 'w-full' : 'w-0 group-hover:w-full'
                }
                ${isScrolled ? 'bg-black text-primary-700' : 'bg-gradient-to-r from-primary-400 to-primary-700'}
                `}></div>
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
          {/*  <button className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 ${*/}
          {/*    isScrolled*/}
          {/*      ? 'bg-gray-100 hover:bg-gray-200 text-gray-700 hover:text-gray-900'*/}
          {/*      : 'bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border border-white/20'*/}
          {/*  }`}>*/}
          {/*    <i className="fas fa-search mr-2"></i>*/}
          {/*    搜索*/}
          {/*  </button>*/}
          </div>

          <button
            className={`lg:hidden p-3 rounded-xl transition-all duration-300 transform hover:scale-110 ${
              isScrolled
                ? 'text-primary-700 hover:text-primary-600 hover:bg-primary-100'
                : 'text-primary-500 hover:text-primary-300 hover:bg-white/10'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'} text-xl transition-transform duration-300 ${isMobileMenuOpen ? 'rotate-180' : ''}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-gray-200 shadow-xl">
            <nav className="py-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`block px-6 py-4 font-semibold transition-all duration-300 hover:bg-primary-50 hover:text-primary-600 active:bg-primary-100 ${
                    location.pathname === item.path
                      ? 'text-primary-600 bg-primary-50 border-r-4 border-primary-900'
                      : 'text-primary-700'
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
              <div className="px-6 py-4 space-y-3 border-t border-gray-200 mt-4">
                {/*<button className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 hover:text-gray-900 px-6 py-3 rounded-full font-semibold transition-all duration-300 min-h-[48px] flex items-center justify-center">*/}
                {/*  <i className="fas fa-search mr-2"></i>*/}
                {/*  搜索*/}
                {/*</button>*/}
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;